import "react";
import { Button, ButtonGroupToggle } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Calendar/CalendarToolbar.tsx
var VIEWS = [{
	key: "week",
	label: "Week"
}, {
	key: "month",
	label: "Month"
}];
function CalendarToolbar(props) {
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-sm flex flex-wrap items-center",
		children: [
			/* @__PURE__ */ jsx(ButtonGroupToggle, {
				activeKey: props.view,
				buttons: VIEWS,
				onKeyPress: props.onViewChange,
				size: "sm"
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "gap-xxs flex items-center",
				children: [
					/* @__PURE__ */ jsx(Button, {
						"aria-label": "Previous",
						onClick: props.onPrev,
						size: "sm",
						subtle: true,
						children: "‹"
					}),
					/* @__PURE__ */ jsx(Button, {
						onClick: props.onToday,
						size: "sm",
						subtle: true,
						children: "Today"
					}),
					/* @__PURE__ */ jsx(Button, {
						"aria-label": "Next",
						onClick: props.onNext,
						size: "sm",
						subtle: true,
						children: "›"
					})
				]
			}),
			/* @__PURE__ */ jsx("span", {
				className: "text-color-strong text-sm font-semibold",
				children: props.rangeLabel
			})
		]
	});
}
//#endregion
export { CalendarToolbar };

//# sourceMappingURL=CalendarToolbar.js.map